// Wrappers para /api/catalogs/*.

import { apiFetch } from './api';

export interface CatalogLicense {
  id: number;
  slug: string;
  label: string;
  monthly_sessions_one: number;
  monthly_sessions_gr: number;
  default_duration_one_min: number;
  default_duration_gr_min: number;
}

export async function listLicenses(): Promise<CatalogLicense[]> {
  const r = await apiFetch<{ status: 'ok'; items: CatalogLicense[] }>('/catalogs/licenses');
  return r.items;
}

export interface CatalogLevel {
  id: number;
  slug: string;
  label: string;
  order_index: number;
}

export async function listLevels(): Promise<CatalogLevel[]> {
  const r = await apiFetch<{ status: 'ok'; items: CatalogLevel[] }>('/catalogs/levels');
  return r.items;
}
